<template>
  <div class="template-codes">
    <el-table
      :data="codes"
      style="width: 100%"
    >
      <el-table-column
        label="online"
        width="70"
      >
        <template slot-scope="scope">
          <div
            :class="{ online: scope.row.online, offline: !scope.row.online }"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本"
        width="100"
      />
      <el-table-column
        prop="author"
        label="作者"
      />
      <el-table-column label="上传时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | dateFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column label="编译状态">
        <template slot-scope="scope">
          <div v-if="scope.row.buildStatus === 'failed'">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.buildMessage"
              placement="top-end"
            >
              <span>{{ scope.row.buildStatus }}</span>
            </el-tooltip>
          </div>
          <div v-else>
            <span>{{ scope.row.buildStatus }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="最后发布日期">
        <template slot-scope="scope">
          <div v-if="!!scope.row.publishedAt">
            <span>{{ scope.row.publishedAt | dateFormat }}</span>
          </div>
          <div v-else>
            -
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        width="200"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.buildStatus === 'succeed'">
            <el-button
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'templatePreview',
                  params: { templateId },
                  query: { version: scope.row.version }
                })
              "
            >
              预览
            </el-button>

            <el-button
              v-if="
                $hasPermission('templatePublish') &&
                  scope.row.buildStatus === 'succeed'
              "
              size="small"
              type="text"
              @click="publishTpl(scope.row.version)"
            >
              发布
            </el-button>
          </div>
          <div v-else-if="scope.row.buildStatus === 'failed'">
            <el-button
              v-if="$hasPermission('templateCompile')"
              size="small"
              type="text"
              @click="rebuildTpl(scope.row.version)"
            >
              重新编译
            </el-button>
          </div>
          <div v-else>
            -
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="less" scoped>
// 控制层高度
@controls-height: 45px;
// 间隙
@gap-height: 15px;

@template-cover-width: 200px;
@template-cover-height: 112.3px;

.offline,
.online {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: #8bc34a 1px solid;
}

.online {
  background-color: #8bc34a;
}

.el-form-item__content::after {
  clear: inherit;
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:template_codes');
import axios from 'axios';

export default {
	data() {
		return {
			templateId: null,
			addTemplateCodeDialogVisible: false,
			codes: []
		};
	},

	async created() {
		return this.init();
	},

	methods: {
		async init() {
			const { templateId } = this.$route.params;
			const codes = await axios.get(`/api/templates/${templateId}/codes`);
			debug('[init] templateId: %s, code: %o', templateId, codes);
			this.templateId = templateId;
			this.codes = codes;
		},

		// 模板发布
		async publishTpl(version) {
			await axios.put(`/api/templates/${this.templateId}/publish`, { version });
			await this.init();
		},

		// 模板重新编译
		async rebuildTpl(version) {
			await axios.put(`/api/templates/${this.templateId}/recompile`, {
				version
			});
			await this.init();
		}
	}
};
</script>
